export default __webpack_public_path__ + "static/media/Video_Section_mobile.7a006810.png";